import { toastify } from "./toastify";

export const missingPopup = (field) => {
  toastify(`${field} is missing`, "error");
};
